export var E_CASE_DETAILS_MODAL;
(function (E_CASE_DETAILS_MODAL) {
    E_CASE_DETAILS_MODAL[E_CASE_DETAILS_MODAL["REASSIGN_CASE"] = 0] = "REASSIGN_CASE";
    E_CASE_DETAILS_MODAL[E_CASE_DETAILS_MODAL["REFUSAL_ABORT"] = 1] = "REFUSAL_ABORT";
    E_CASE_DETAILS_MODAL[E_CASE_DETAILS_MODAL["INCOMPLETE"] = 2] = "INCOMPLETE";
    E_CASE_DETAILS_MODAL[E_CASE_DETAILS_MODAL["VALID_IDENTITY"] = 3] = "VALID_IDENTITY";
    E_CASE_DETAILS_MODAL[E_CASE_DETAILS_MODAL["INCOMPLETE_IDENTITY"] = 4] = "INCOMPLETE_IDENTITY";
    E_CASE_DETAILS_MODAL[E_CASE_DETAILS_MODAL["INVALID_IDENTITY"] = 5] = "INVALID_IDENTITY";
    E_CASE_DETAILS_MODAL[E_CASE_DETAILS_MODAL["RESEND_RECONNECTION_LINK"] = 6] = "RESEND_RECONNECTION_LINK";
    E_CASE_DETAILS_MODAL[E_CASE_DETAILS_MODAL["OTHER"] = 7] = "OTHER";
})(E_CASE_DETAILS_MODAL || (E_CASE_DETAILS_MODAL = {}));
export var E_CASE_ACTION_TASK;
(function (E_CASE_ACTION_TASK) {
    E_CASE_ACTION_TASK[E_CASE_ACTION_TASK["MODAL"] = 0] = "MODAL";
    E_CASE_ACTION_TASK[E_CASE_ACTION_TASK["REDIRECT"] = 1] = "REDIRECT";
})(E_CASE_ACTION_TASK || (E_CASE_ACTION_TASK = {}));
